module.exports = __webpack_public_path__ + "img/hero-frog-bg.10c0b3aa.jpg";